<template>
  <div class="overflow-hidden">
    <div class="font-style-spp">
      <VideoFrame :openVideo.sync="openVideo" />
      <Menu @openVideo="openVideo = true" />
      <Banner />
      <br />
      <br />
      <br />
      <br />
      <Introducing />
      <ProductConf />
      <Whyscancom />
      <Footer />
    </div>
  </div>
</template>
<script>
import VideoFrame from "./VideoFrame.vue";
import Menu from "./Menu.vue";
import Banner from "./Banner.vue";
import Introducing from "./Introducing.vue";
import ProductConf from "./ProductConf.vue";
import Whyscancom from "./Whyscancom.vue";
import Footer from "./Footer.vue";
export default {
  components: {
    VideoFrame,
    Menu,
    Banner,
    Introducing,
    ProductConf,
    Whyscancom,
    Footer,
  },
  data() {
    return {
      openVideo: true,
    };
  },
};
</script>
<style>
.font-style-spp {
  font: normal 300 "Poppins", sans-serif;
  color: #333;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  color: #333;
}
p {
  font-size: 14px;
}
::selection {
  color: #fff;
  background: #02233e;
}
</style>
